import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import { urlHashDatePicker } from 'constants/url'
import { EmptyObject } from 'lib/object/objectUtils'
import offerPageURL from 'lib/offer/offerPageURL'
import { buildSearchParamsFromFilters } from 'lib/search/searchUtils'
import React, { useMemo } from 'react'
import { OfferUnavailableReason } from 'lib/search/constants'

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary | App.BundleOffer
  unavailableReason: string | undefined
  filters?: App.OfferListFilters
}

function HotelSearchTileUnavailabilityBanner({
  offer,
  unavailableReason,
  filters = EmptyObject,
}: Props) {
  const bannerMessage = useMemo(() => {
    if (offer.isSoldOut) return 'Sold out for your dates'
    if (unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED) {
      return 'Unavailable for the number of guests selected'
    }

    return 'Unavailable for your dates'
  }, [offer, unavailableReason])

  const offerUrl = useMemo(() => {
    const searchParams = buildSearchParamsFromFilters({
      ...filters,
      checkIn: undefined,
      checkOut: undefined,
    })

    if (unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED) return offerPageURL(offer, searchParams)

    return offerPageURL(offer, searchParams) + urlHashDatePicker
  }, [filters, offer, unavailableReason])

  return (
    <MessageBanner
      kind="informational-primary"
      description={<b>{bannerMessage}</b>}
      primaryActionButtonProps={{
        children:
          unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED ? 'View offer' : 'View available dates',
        to: offerUrl,
      }}
    />
  )
}

export default HotelSearchTileUnavailabilityBanner
